import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, forkJoin, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { defaultIfEmpty } from 'rxjs/operators';
import { Cashback } from '../_models/cashback.model';
import { Page } from '@interfaces/page';
import { ListCashback } from '../_models/list-cashbacks.model';
import { SortingPagingData } from '@helpers/sorting-paging-data';

const apiServerUrl                       = environment.apiBaseURL;
const cashbacksUrl                      = apiServerUrl + '/cashback';

const findCashbackByIdURL                         = cashbacksUrl + '/{id}';
const findCashbackPageableURL                     = cashbacksUrl + '/pageable';
const countCashbackPageableURL                    = cashbacksUrl + '/pageable-count';

@Injectable({
  providedIn: 'root'
})
export class CashbackService {

  constructor(
    private http: HttpClient
  ) { }

  public findCashbackById(id: number): Observable<Cashback> {
    if (id === undefined || id === null) {
      return EMPTY.pipe(
        defaultIfEmpty()
      );
    }
    return this.http.get<Cashback>(findCashbackByIdURL.replace('{id}', `${id}`));
  }

  public saveCashback(cashback: Cashback, deactivate: boolean = false): Observable<any> {
    let requestParams = new HttpParams();
    requestParams = requestParams.set("deactivate", deactivate.toString());

    return this.http.post(cashbacksUrl, cashback, {params: requestParams});
  }

  public pageableCashbacks(sortingPaging: SortingPagingData, searchForm: any) {
    return forkJoin([
      this.findAllCashbacksByFilter(sortingPaging, searchForm),
      this.countAllCashbacksByFilter(sortingPaging, searchForm)
    ]);
  }

  public findAllCashbacksByFilter(sortingPaging: SortingPagingData, searchForm: any): Observable<Page<ListCashback>> {
    return this.http.get<Page<ListCashback>>(findCashbackPageableURL, { params: this.createSearchHttpRequestParams(sortingPaging, searchForm) });
  }

  public countAllCashbacksByFilter(sortingPaging: SortingPagingData, searchForm: any): Observable<number> {
    return this.http.get<number>(countCashbackPageableURL, { params: this.createSearchHttpRequestParams(sortingPaging, searchForm) });
  }

  private createSearchHttpRequestParams(sortingPaging: SortingPagingData, searchForm: any): HttpParams {
    let params = new HttpParams().set('pageSize', sortingPaging.pageSize.toString())
                                .set('page', sortingPaging.pageNumber.toString());
                                
    if (sortingPaging.isSortingValid()) {
      params = params
        .set("sortBy", sortingPaging.sortBy)
        .set("sortAsc", sortingPaging.sortAsc === null ? 'null' : (sortingPaging.sortAsc ? 'true' : 'false'));
    }

    // Add search parameters
    if (searchForm.serviceType && searchForm.serviceType.id) {
      params = params.set('serviceTypeId', searchForm.serviceType.id.toString());
    }

    if (searchForm.service && searchForm.service.id) {
      params = params.set('serviceId', searchForm.service.id.toString());
    }

    if (searchForm.status && searchForm.status.id) {
      params = params.set('statusId', searchForm.status.id.toString());
    }

    return params;
  }
}
